// extracted by mini-css-extract-plugin
export default {"main":"Numerator_main__IcHrK","number":"Numerator_number__qD-QY"};